
const PasswordRules = (props) => {

    
    return (
       <div >
		  <h1 >
			Password Guidelines
		  </h1>
		  <div>
			{/* top li section */}

			<ul>
			  <li >
				<span className="text-black">Case Sensitive</span>
			  </li>
			  <li >
				<span className="text-black">
				  Must be-8-32 character long and just contain three of the
				  following four categories:
				</span>
			  </li>
			</ul>

			{/* middle li section */}
			<ul >
			  <li>
				<span className="text-black">Upper-case letters</span>
			  </li>
			  <li >
				<span className="text-black">Lower-case letters</span>
			  </li>
			  <li >
				<span className="text-black">Special Characters</span>
			  </li>
			  <li >
				<span className="text-black">Numbers</span>
			  </li>
			</ul>

			{/* bottom li section */}
			<ul >
			  <li >
				<span className="text-black">No spaces are allowed.</span>
			  </li>
			  <li >
				<span className="text-black">
				  Your user ID and password must be different.
				</span>
			  </li>
			</ul>
		  </div>
    </div>
    );
};

export default PasswordRules;